import { withBasePath } from '../../basePath';
import { I18nLocale, t } from '@ardoq/i18n';
import { Text } from '@ardoq/typography';
import { CHAT_INPUT_ANCHOR_ID } from 'assistant/components/ChatFooter';
import { EphemeralPopoverNotificationContent } from '../types';

export const getConditionalFormattingAiOnboardingContent = (
  i18nLocale: I18nLocale
): EphemeralPopoverNotificationContent => ({
  cards: [
    {
      content: (
        <img
          style={{ width: '100%' }}
          alt={t(
            i18nLocale,
            'ephemeralNotification:conditionalFormattingAi.previewAlt',
            'Format with AI preview'
          )}
          src={withBasePath(
            '/img/ai-formatting-onboarding/conditional-formatting.png'
          )}
        />
      ),
      header: t(
        i18nLocale,
        'ephemeralNotification:conditionalFormattingAi.header',
        'Format with AI'
      ),
      bodyText: (
        <Text variant="text2">
          {t(
            i18nLocale,
            'ephemeralNotification:conditionalFormattingAi.bodyText',
            'Describe what you want to color, and the AI Assistant will create the formatting rules for you.'
          )}
        </Text>
      ),
    },
  ],
  anchor: {
    target: `#${CHAT_INPUT_ANCHOR_ID}`,
    placement: { side: 'left', overflow: 'bottom' },
  },
  endButtonLabel: t(i18nLocale, 'ephemeralNotification:gotItButton', 'Got it'),
});

export const getLabelsAiOnboardingContent = (
  i18nLocale: I18nLocale
): EphemeralPopoverNotificationContent => ({
  cards: [
    {
      content: (
        <img
          style={{ width: '100%' }}
          alt={t(
            i18nLocale,
            'ephemeralNotification:labelsAi.previewAlt',
            'Label with AI preview'
          )}
          src={withBasePath('/img/ai-formatting-onboarding/labels.png')}
        />
      ),
      header: t(
        i18nLocale,
        'ephemeralNotification:labelsAi.header',
        'Label with AI'
      ),
      bodyText: (
        <Text variant="text2">
          {t(
            i18nLocale,
            'ephemeralNotification:labelsAi.bodyText',
            'Describe the labels you want to add, and the AI Assistant will create the rules for you.'
          )}
        </Text>
      ),
    },
  ],
  anchor: {
    target: `#${CHAT_INPUT_ANCHOR_ID}`,
    placement: { side: 'left', overflow: 'bottom' },
  },
  endButtonLabel: t(i18nLocale, 'ephemeralNotification:gotItButton', 'Got it'),
});
